//******************************************************************************
//* Constants
//******************************************************************************
BREAKPOINT_SCREEN_XS_MAX = 767;
BREAKPOINT_SCREEN_SM_MAX = 991;
BREAKPOINT_SCREEN_XXS_MAX = 550;
BREAKPOINT_NAV_MOBILE_MAX = 930;